import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoggingService } from '@nx-vigil/core/web/logging/data-access';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardAutoLogin {
  private readonly authService = inject(AuthService);
  private readonly logger = inject(LoggingService);

  public canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    this.logger.trace('AuthGuardAutoLogin#canActivate called', state.url);
    return this.authService.isLoaded$.pipe(
      filter(isDone => isDone),
      switchMap(() => this.authService.isAuthenticated$),
      tap(
        isAuthenticated => isAuthenticated || this.authService.login(state.url),
      ),
    );
  }
}
